import storage from './storage';
import languageData, { getSupportedLanguages } from '../components/LanguageSwitcher/data';

const getDefaultLocale = () => {
  const defaultLang = window.DEFAULT_LANGUAGE || 'en';
  return languageData.find(({ locale }) => locale === defaultLang) || languageData[0];
};

export const getStoredLocale = () => storage.locale.get() || getDefaultLocale();

export const setStoredLocale = (locale) => storage.locale.set(locale);

export const findLocaleByParam = (langParam) => {
  if (!langParam) return null;

  const supportedLanguages = getSupportedLanguages();
  return supportedLanguages.find(
    (lang) => lang.locale === langParam || lang.languageId === langParam.toLowerCase(),
  );
};

export const applyLocaleFromQueryParam = (langParam) => {
  const localeConfig = findLocaleByParam(langParam);
  if (localeConfig) {
    setStoredLocale(localeConfig);
  }
  return localeConfig;
};
